import React, { useState } from "react";
import Index from "./pages/index";
import Home from "./pages/home"; // your patient dashboard component

export default function App() {
  const [showIndex, setShowIndex] = useState(true);

  return showIndex ? (
    <Index onEnter={() => setShowIndex(false)} />
  ) : (
    <Home />
  );
}